import React, { useState } from "react";
import { InfoIcon } from "../../../../../assets/Icons/InfoIcon";
import { Button } from "../../../../../shared/Button/Button";
import { ModalInfo } from "../../../../../boxes/ModalInfo/ModalInfo";
import styles from "./styles.module.scss";

export const SatisfactionTip = () => {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <>
      <Button
        size="small"
        variant="text"
        onClick={open}
        className={styles.button}
      >
        <InfoIcon width="17px" />
      </Button>
      {isOpen && (
        <ModalInfo
          isOpen
          onClose={close}
          onOk={close}
          titleSuffix="- Survey Satisfaction Breakdown"
        >
          <p>
            The percentages shown represent the portion of surveys in each
            satisfaction category:
          </p>
          <ul className={styles.list}>
            <li>
              <b>High:</b> 75%+ satisfaction (score 4+)
            </li>
            <li>
              <b>Average:</b> 50-75% satisfaction (score 2.5-4)
            </li>
            <li>
              <b>Low:</b> {`Under 50% satisfaction (score <2.5)`}
            </li>
          </ul>
        </ModalInfo>
      )}
    </>
  );
};
